import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	padbottom:'1.173333rem',
    isIphoneX:false,
  	isShowLoad:false,
    pcLogin:0,
    smallNum:'',
    isUpdate:false,
    isTelAddAlert:false,
    isHorizontal:false,
  },
  mutations: {
  	changeIphoneXBtoom(state){
  		// state.padbottom = '1.58rem'
      state.isIphoneX = true;
  	},
  	showLoad(state){
  		state.isShowLoad = true;
  	},
  	closeLoad(state){
  		state.isShowLoad = false;
  	},
    PCLogin(state){
      state.pcLogin = 492;
    },
    changeSmall(state){
      state.smallNum = 492;
    },
    changeUpdateStatus(state,status){
      state.isUpdate = status;
    },
    showTelAddAlert(state){
      state.isTelAddAlert = true;
    },
    closeTelAddAlert(state){
      state.isTelAddAlert = false;
    },
    horizontalShow(state){
      state.isHorizontal = true;
    },
    verticalShow(state){
      state.isHorizontal = false;
    },
  },
  actions: {

  }
})
